import { useCallback, useEffect, useState, memo } from 'react';

import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';

import { FactRow } from './FactRow';
import useToggleIncluded from '../../../../../../api/mutations/useToggleIncluded';
import IncludeCheckbox from '../../components/IncludeCheckbox';
import EmptyState from '@/components/molecules/EmptyState';
import FactDropdown from '@/components/organisms/FactDropdown';
import { cn } from '@/helpers/shadCnUtils';
import { Fact, Relevance } from '@/types';

interface FactEditorTableProps {
  facts: Fact[];
  keyFactIdSet: Set<string>;
  caseId: string;
  setTotalNumberOfIncludedFacts: (v: number | ((prev: number) => number)) => void;
  checkIfAllSelected: (caseId: string) => void;
  includedFactsCount: number;
}

const FactsEditorTable = ({
  facts,
  keyFactIdSet,
  caseId,
  setTotalNumberOfIncludedFacts,
  checkIfAllSelected,
  includedFactsCount,
}: FactEditorTableProps) => {
  const [searchParams] = useSearchParams();
  const factId = searchParams.get('factId');

  return (
    <div className={cn('flex h-full flex-col gap-2 pt-1 pb-6')}>
      {facts.length === 0 && (
        <EmptyState title="No facts found" subtitle="Sorry, we couldn't find any facts matching these criteria." />
      )}

      {facts.map((fact) => (
        <FactRow
          fact={fact}
          key={fact.id}
          highlightedFactId={factId ?? undefined}
          keyFactIdSet={keyFactIdSet}
          setTotalNumberOfIncludedFacts={setTotalNumberOfIncludedFacts}
          checkIfAllSelected={checkIfAllSelected}
          caseId={caseId}
          includedFactsCount={includedFactsCount}
        />
      ))}
    </div>
  );
};

export default FactsEditorTable;
